/*
 * Cilek PDP buy zone behaviour, shared by the cilek-pdp and cilek-pdp-mebel templates
 * (markup: snippets/cilek-buy-zone.liquid).
 *  1. Delivery estimate: recomputes "доставка между DD.MM и DD.MM" with the visitor's date
 *     (the page can be served from cache), counting working days for "работни дни" bands, and
 *     recomputes the product's own Christmas last order day, hiding the note after it.
 *  2. Phone order ("Поръчай с 1 клик"): validates a Bulgarian number before anything is sent,
 *     then lets Shopify's invisible hCaptcha post the native contact form; the page returns with
 *     ?contact_posted=true and the server-rendered success state, where GA4 generate_lead and
 *     Meta Lead fire once (when those trackers exist). Without a captcha on the page the form
 *     is posted with fetch and the success state is shown inline.
 *  3. Mobile sticky bar: visible whenever the main add-to-cart button is out of the viewport.
 *     While visible it sets html.cilek-sticky-atc-visible and --cilek-sticky-atc-h so floating
 *     buttons (Viber/call) can sit above it.
 */
(function () {
  'use strict';
  if (window.__cilekBuyZone) return;
  window.__cilekBuyZone = true;

  var NBSP = ' ';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // Same rule as snippets/cilek-bz-money.liquid: exact amount, ",00" omitted, NBSP separators.
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var sign = cents < 0 ? '-' : '';
    cents = Math.abs(cents);
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    if (rest) out += ',' + pad(rest);
    return sign + out + NBSP + '€';
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- 1. Delivery estimate ---------- */
  // Same math as the 'eta' part of snippets/cilek-buy-zone.liquid: weeks and calendar days are added
  // as days; working days ("работни дни") skip Saturdays, Sundays and the non-working days in settings.
  function ymd(d) {
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  function dayMonth(d) {
    return pad(d.getDate()) + '.' + pad(d.getMonth() + 1);
  }

  function shift(d, days) {
    var out = new Date(d.getTime());
    out.setDate(out.getDate() + days);
    return out;
  }

  function isWorkday(d, holidays) {
    var wd = d.getDay();
    if (wd === 0 || wd === 6) return false;
    var dm = dayMonth(d);
    return holidays.indexOf(',' + dm + ',') === -1 && holidays.indexOf(',' + dm + '.' + d.getFullYear() + ',') === -1;
  }

  // The date that is n units after "from".
  function addBand(from, n, unit, holidays) {
    if (unit !== 'bday') return shift(from, n * (unit === 'week' ? 7 : 1));
    var d = from;
    for (var count = 0, guard = 0; count < n && guard < 400; guard++) {
      d = shift(d, 1);
      if (isWorkday(d, holidays)) count++;
    }
    return d;
  }

  // The last day an order can be placed so that "from + n units" is still on or before "target".
  function lastOrderDay(target, n, unit, holidays) {
    if (unit !== 'bday') return shift(target, -n * (unit === 'week' ? 7 : 1));
    var d = target;
    var i;
    for (i = 0; i < 30 && !isWorkday(d, holidays); i++) d = shift(d, -1);
    for (var count = 0, guard = 0; count < n && guard < 400; guard++) {
      d = shift(d, -1);
      if (isWorkday(d, holidays)) count++;
    }
    for (i = 0; i < 30 && !isWorkday(shift(d, 1), holidays); i++) d = shift(d, 1);
    return d;
  }

  function initEta(el) {
    var unit = el.getAttribute('data-unit');
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var holidays = (el.getAttribute('data-holidays') || ',').replace(/\s+/g, '');
    if (!unit || isNaN(min) || isNaN(max)) return;
    var today = new Date();
    today.setHours(12, 0, 0, 0);

    var from = el.querySelector('[data-eta-from]');
    var to = el.querySelector('[data-eta-to]');
    if (from) from.textContent = dayMonth(addBand(today, min, unit, holidays));
    if (to) to.textContent = dayMonth(addBand(today, max, unit, holidays));

    var xmas = el.querySelector('[data-xmas-target]');
    if (!xmas) return;
    var t = parseInt(xmas.getAttribute('data-xmas-target'), 10);
    if (isNaN(t)) return;
    var target = new Date(Math.floor(t / 10000), Math.floor(t / 100) % 100 - 1, t % 100, 12, 0, 0, 0);
    var cutoff = lastOrderDay(target, min, unit, holidays);
    if (ymd(today) > ymd(cutoff)) {
      xmas.parentNode.removeChild(xmas);
      return;
    }
    var label = xmas.querySelector('[data-xmas-date]');
    if (label) label.textContent = dayMonth(cutoff);
  }

  /* ---------- 2. Phone order form ---------- */
  function normalizePhone(value) {
    return String(value || '').replace(/[\s\-().\/]/g, '');
  }

  // Bulgarian numbers only. "+359 ...", "00359 ...", "359 ..." and "0..." are the same number.
  // After the leading 0 comes the area or mobile code, which never starts with 0 or 1.
  // Mobile numbers (087, 088, 089, 098, 099) have 9 digits after the 0, landlines
  // (02 Sofia, 032 Plovdiv, 052 Varna, 0700 ...) have 8.
  function validBgPhone(phone) {
    var national = phone;
    if (/^\+359/.test(national)) national = '0' + national.slice(4);
    else if (/^00359/.test(national)) national = '0' + national.slice(5);
    else if (/^359\d{8,9}$/.test(national)) national = '0' + national.slice(3);
    if (!/^0[2-9]\d+$/.test(national)) return false;
    var digits = national.slice(1);
    return /^(?:87|88|89|98|99)/.test(digits) ? digits.length === 9 : digits.length === 8;
  }

  function readConfig(wrap) {
    var node = wrap.querySelector('[data-cilek-qo-config]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  // Fires GA4 generate_lead and Meta Lead once each. The trackers can load after this script
  // (consent banner, async tags), so each one is retried for up to 10 seconds.
  function trackLead(cfg) {
    var value = Math.round(Number(cfg.price) || 0) / 100;
    var id = cfg.sku || String(cfg.variantId || '');
    var sentGa = false;
    var sentFb = false;
    var tries = 0;
    (function attempt() {
      if (!sentGa && typeof window.gtag === 'function') {
        sentGa = true;
        try {
          window.gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: value,
            lead_source: 'pdp_phone_order',
            items: [{ item_id: id, item_name: cfg.title, item_variant: cfg.variant || undefined, price: value, quantity: 1 }]
          });
        } catch (e) {}
      }
      if (!sentFb && typeof window.fbq === 'function') {
        sentFb = true;
        try {
          window.fbq('track', 'Lead', { content_name: cfg.title, content_ids: [id], content_type: 'product', value: value, currency: 'EUR' });
        } catch (e) {}
      }
      if ((!sentGa || !sentFb) && ++tries < 40) setTimeout(attempt, 250);
    })();
  }

  function initQuickOrder(wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;
    var cfg = readConfig(wrap);

    // Native flow came back from Shopify (after a captcha): show the server-rendered success once.
    var posted = wrap.querySelector('[data-cilek-qo-posted]');
    if (posted) {
      var key = 'cilek_qo_lead_' + location.pathname;
      var already = false;
      try {
        already = sessionStorage.getItem(key) === '1';
        sessionStorage.setItem(key, '1');
      } catch (e) {}
      if (!already) trackLead(cfg);
      try {
        var cleanUrl = new URL(location.href);
        cleanUrl.searchParams.delete('contact_posted');
        history.replaceState(history.state, '', cleanUrl.toString());
      } catch (e) {}
      // Run after the browser's own jump to #CilekQuickOrder-..., so the message ends up centred and announced.
      var settle = function () {
        wrap.scrollIntoView({ block: 'center', behavior: 'auto' });
        try {
          posted.focus({ preventScroll: true });
        } catch (e) {}
      };
      if (document.readyState === 'complete') setTimeout(settle, 60);
      else window.addEventListener('load', function () { setTimeout(settle, 60); });
      return;
    }

    // Keep the order details in step with Dawn's variant picker (products with real variants).
    try {
      // PUB_SUB_EVENTS is a global const (constants.js), not a window property.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var v = event && event.data && event.data.variant;
          if (!v) return;
          cfg.variantId = v.id;
          cfg.sku = v.sku || cfg.sku;
          cfg.price = v.price;
          cfg.variant = v.title && v.title !== 'Default Title' ? v.title : '';
        });
      }
    } catch (e) {}

    var input = form.querySelector('[data-qo-phone]');
    var consent = form.querySelector('[data-qo-consent]');
    var msg = form.querySelector('[data-qo-msg]');
    var btn = form.querySelector('[data-qo-submit]');
    var body = form.querySelector('[data-qo-body]');
    var success = form.querySelector('[data-qo-success]');
    var successText = form.querySelector('[data-qo-success-text]');
    var serverError = form.querySelector('[data-cilek-qo-error]');
    if (!input || !btn || !msg) return;
    var btnLabel = btn.textContent;

    function show(text, kind) {
      if (serverError) {
        serverError.parentNode.removeChild(serverError);
        serverError = null;
      }
      msg.textContent = text || '';
      msg.hidden = !text;
      msg.className = 'cilek-bz-quick-order-msg' + (kind ? ' is-' + kind : '');
    }

    function busy(on) {
      btn.disabled = on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      btn.textContent = on && cfg.msgSending ? cfg.msgSending : btnLabel;
    }

    // The visitor's cart, read ahead so the email can list it (the native captcha post leaves no time to fetch).
    var cartCache = null;
    function loadCart() {
      if (!window.fetch) return;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { cartCache = c; })
        .catch(function () {});
    }
    loadCart();
    input.addEventListener('focus', loadCart);
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, loadCart);
    } catch (e) {}

    function text(el) {
      return el ? (el.innerText || el.textContent).replace(/\s+/g, ' ').trim() : '';
    }

    function buildBody(phone) {
      var lines = [
        'Поръчка по телефона (Поръчай с 1 клик)',
        'Телефон: ' + phone,
        '',
        'ПРОДУКТ',
        'Продукт: ' + (cfg.title || ''),
        'Код: ' + (cfg.sku || '')
      ];
      if (cfg.variant) lines.push('Вариант: ' + cfg.variant + ' (' + cfg.variantId + ')');
      if (cfg.color) lines.push('Цвят: ' + cfg.color);
      var price = 'Цена: ' + money(cfg.price);
      if (Number(cfg.compareAt) > Number(cfg.price)) {
        price += ' (редовна ' + money(cfg.compareAt) + ', -' + Math.round((1 - cfg.price / cfg.compareAt) * 100) + '%)';
      }
      lines.push(price);
      if (cfg.band) lines.push('Срок за изработка: ' + cfg.band);
      lines.push('Адрес: ' + (cfg.url || location.href.split('?')[0]));

      var upsell = [];
      var mattressRoot = document.querySelector('[data-cilek-section="mattress"]');
      var mattresses = mattressRoot && !mattressRoot.hidden ? mattressRoot.querySelectorAll('.cilek-mattress__item:not([hidden])') : [];
      if (cfg.mattressSize || mattresses.length) {
        var m = 'Матрак: леглото е за матрак ' + (cfg.mattressSize || '?') + '.';
        if (mattresses.length) {
          m += ' Предложение: ' + Array.prototype.map.call(mattresses, function (li) {
            var sale = li.querySelector('.cilek-mattress__price-sale');
            return text(li.querySelector('.cilek-mattress__name')) + ' ' + text(li.querySelector('.cilek-mattress__size')) + ', ' + text(sale || li.querySelector('.cilek-mattress__price'));
          }).join('; ');
        }
        upsell.push(m);
      }
      if (cfg.seriesName) upsell.push('Серия: ' + cfg.seriesName + ', още мебели от нея: ' + cfg.seriesUrl);
      var place = document.querySelector('.cilek-bz-delivery__input');
      var result = document.querySelector('.cilek-bz-delivery__result');
      if (place && place.value.trim() && text(result)) upsell.push('Калкулатор за доставка: ' + place.value.trim() + '. ' + text(result));
      if (upsell.length) {
        lines.push('', 'ВЪЗМОЖНОСТИ ЗА ДОПЪЛНИТЕЛНА ПРОДАЖБА');
        upsell.forEach(function (u) { lines.push('- ' + u); });
      }

      if (cartCache && cartCache.items && cartCache.items.length) {
        lines.push('', 'КОЛИЧКАТА НА КЛИЕНТА (' + money(cartCache.total_price) + ')');
        cartCache.items.forEach(function (it) {
          lines.push('- ' + it.quantity + ' x ' + it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '') + ', ' + money(it.final_line_price) + (it.sku ? ', код ' + it.sku : ''));
        });
      }

      var utm = [];
      try {
        new URLSearchParams(location.search).forEach(function (v, k) { if (/^utm_/.test(k)) utm.push(k + '=' + v); });
      } catch (e) {}
      if (utm.length) lines.push('', 'Източник: ' + utm.join(', '));

      if (cfg.callNotes) lines.push('', 'ЗА ОБАЖДАНЕТО', cfg.callNotes);
      lines.push('', 'Общи условия: приети');
      return lines.join('\n');
    }

    function done(phone) {
      busy(false);
      show('');
      Array.prototype.forEach.call(form.children, function (child) {
        if (child !== success && child.tagName !== 'INPUT' && child.tagName !== 'TEXTAREA') child.hidden = true;
      });
      if (successText) successText.textContent = cfg.successText || '';
      if (success) {
        success.hidden = false;
        success.focus({ preventScroll: true });
      }
      trackLead(cfg);
      try {
        document.dispatchEvent(new CustomEvent('cilek:quick-order:success', { detail: { phone: phone, sku: cfg.sku } }));
      } catch (e) {}
    }

    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid')) {
        input.removeAttribute('aria-invalid');
        show('');
      }
    });
    if (consent) {
      consent.addEventListener('change', function () {
        if (consent.checked && consent.getAttribute('aria-invalid')) {
          consent.removeAttribute('aria-invalid');
          show('');
        }
      });
    }

    var state = 'idle';
    var resubmit = false;
    var waitedForBind = false;
    var watchdog = null;

    function captchaChallengeOpen() {
      return Array.prototype.some.call(document.querySelectorAll('iframe[src*="hcaptcha"]'), function (frame) {
        var r = frame.getBoundingClientRect();
        return r.width > 100 && r.height > 100 && r.bottom > 0 && r.top < window.innerHeight && getComputedStyle(frame).visibility !== 'hidden';
      });
    }

    function captchaActive() {
      return !!(window.Shopify && window.Shopify.captcha) && form.getAttribute('data-nocaptcha') !== 'true';
    }

    function fail(el, text) {
      el.setAttribute('aria-invalid', 'true');
      show(text, 'error');
      el.focus();
    }

    function reset(withError) {
      clearTimeout(watchdog);
      state = 'idle';
      busy(false);
      if (withError) show(cfg.msgError, 'error');
    }

    function postWithFetch(phone) {
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      })
        .then(function (res) {
          var url = res.url || '';
          if (url.indexOf('/challenge') !== -1) {
            // Shopify wants a captcha page: hand over to the normal form post, it comes back with ?contact_posted=true.
            form.setAttribute('data-native-submit', '1');
            HTMLFormElement.prototype.submit.call(form);
            return null;
          }
          return res.text().then(function (html) {
            if (res.ok && (url.indexOf('contact_posted=true') !== -1 || html.indexOf('data-cilek-qo-posted') !== -1)) {
              clearTimeout(watchdog);
              state = 'done';
              done(phone);
            } else {
              reset(true);
            }
          });
        })
        .catch(function () {
          reset(true);
        });
    }

    form.addEventListener('submit', function (event) {
      if (form.getAttribute('data-native-submit') === '1') return;
      var isRetry = resubmit;
      resubmit = false;
      if (state !== 'idle' && !isRetry) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (!isRetry) {
        var phone = normalizePhone(input.value);
        var problem = null;
        if (!phone) problem = [input, cfg.msgEmpty];
        else if (!validBgPhone(phone)) problem = [input, cfg.msgInvalid];
        else if (consent && !consent.checked) problem = [consent, cfg.msgConsent];
        if (problem) {
          // Stop here so Shopify's captcha handler never posts an invalid request.
          event.preventDefault();
          event.stopImmediatePropagation();
          fail(problem[0], problem[1]);
          return;
        }
        input.value = phone;
        if (body) body.value = buildBody(phone);
        show('');
        state = 'sending';
        busy(true);
        clearTimeout(watchdog);
        // If nothing happened (captcha failed or was closed), give the visitor the button back.
        // The clock pauses while an hCaptcha picture challenge is open, so nobody is interrupted mid-puzzle.
        watchdog = setTimeout(function check() {
          if (captchaChallengeOpen()) {
            watchdog = setTimeout(check, 3000);
            return;
          }
          reset(true);
        }, 15000);
      }

      if (form.hasAttribute('data-hcaptcha-bound')) {
        // Shopify's invisible hCaptcha handler runs after this one and posts the form natively;
        // the page returns with ?contact_posted=true and the server-rendered success state.
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      if (captchaActive() && !waitedForBind) {
        // The captcha script binds on first focus; give it a moment, then submit again through it.
        waitedForBind = true;
        var started = Date.now();
        (function waitForBind() {
          if (form.hasAttribute('data-hcaptcha-bound')) {
            resubmit = true;
            if (form.requestSubmit) form.requestSubmit();
            else btn.click();
          } else if (Date.now() - started < 5000) {
            setTimeout(waitForBind, 150);
          } else {
            postWithFetch(normalizePhone(input.value));
          }
        })();
        return;
      }
      postWithFetch(normalizePhone(input.value));
    });
  }

  /* ---------- 3. Mobile sticky bar ---------- */
  function initSticky(bar) {
    var mainBtn = document.querySelector('product-info .product-form__submit, .product-form__submit');
    if (!mainBtn || !('IntersectionObserver' in window)) {
      bar.parentNode.removeChild(bar);
      return;
    }
    // Leave the (possibly transformed) info column so position: fixed is relative to the viewport.
    document.body.appendChild(bar);
    bar.classList.add('is-ready');

    var root = document.documentElement;
    var mobile = window.matchMedia('(max-width: 749px)');
    var atcInView = true;
    var typing = false;
    var shown = false;

    function update() {
      var want = mobile.matches && !atcInView && !typing;
      if (want === shown) {
        if (shown) root.style.setProperty('--cilek-sticky-atc-h', bar.offsetHeight + 'px');
        return;
      }
      shown = want;
      bar.classList.toggle('is-visible', want);
      root.classList.toggle('cilek-sticky-atc-visible', want);
      root.style.setProperty('--cilek-sticky-atc-h', want ? bar.offsetHeight + 'px' : '0px');
    }

    // The bar only appears once the main button has left the viewport through the top (scrolled past).
    // The large bottom root margin counts "still below the fold" as in view, so at load the bar stays
    // hidden and never covers the colour selector; jumps past the button still flip the state.
    new IntersectionObserver(function (entries) {
      atcInView = entries[entries.length - 1].isIntersecting;
      update();
    }, { rootMargin: '0px 0px 10000px 0px' }).observe(mainBtn);

    if (mobile.addEventListener) mobile.addEventListener('change', update);
    window.addEventListener('resize', update, { passive: true });

    // Keep the bar away from the on-screen keyboard while someone types in a buy-zone field.
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      typing = !!(t && t.matches && t.matches('input:not([type=checkbox]):not([type=radio]), textarea, select') && !bar.contains(t));
      update();
    });
    document.addEventListener('focusout', function () {
      setTimeout(function () {
        var a = document.activeElement;
        typing = !!(a && a.matches && a.matches('input:not([type=checkbox]):not([type=radio]), textarea, select') && !bar.contains(a));
        update();
      }, 0);
    });

    var add = bar.querySelector('[data-cilek-sticky-add]');
    if (add) {
      add.addEventListener('click', function () {
        var form = mainBtn.closest('form') || (mainBtn.form || null);
        if (form && form.requestSubmit) form.requestSubmit(mainBtn);
        else mainBtn.click();
      });
    }

    var phoneBtn = bar.querySelector('[data-cilek-sticky-phone]');
    var qo = document.querySelector('.cilek-bz-quick-order');
    if (phoneBtn && !qo) {
      phoneBtn.parentNode.removeChild(phoneBtn);
    } else if (phoneBtn) {
      phoneBtn.addEventListener('click', function () {
        qo.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
        var target = qo.querySelector('[data-qo-phone]:not([hidden])');
        var successEl = qo.querySelector('[data-cilek-qo-posted], [data-qo-success]:not([hidden])');
        setTimeout(function () {
          var el = successEl || target;
          if (el) el.focus({ preventScroll: true });
        }, reducedMotion() ? 0 : 450);
      });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cilek-eta]'), initEta);
    Array.prototype.forEach.call(document.querySelectorAll('.cilek-bz-quick-order'), initQuickOrder);
    var bar = document.querySelector('[data-cilek-sticky]');
    if (bar) initSticky(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
